import * as React from "react";
import { FunctionComponent } from "react";
import { ProgressBar, Row, Col } from "react-bootstrap";

import Control from "./Control";

import "./LabelledProgressBar.scss";

interface LabelledProgressBarProps {
    min: number;
    max: number;
    now: number;
    labelLeft: string;
    labelRight: string;
}

const LabelledProgressBar: FunctionComponent<LabelledProgressBarProps> = props => {
    const resolveLabel = (label: string): string => {
        return label.replace(/\{(\w+)\}/, (match, group): string => {
            switch (group) {
                case "percent":
                    return String(Math.round((props.now / props.max) * 100)) + "%";
                default:
                    return "";
            }
        });
    };

    return (
        <Control>
            <div className="labelled-progress-bar">
                <Row>
                    <Col xs={9} className="label-left">
                        {resolveLabel(props.labelLeft)}
                    </Col>
                    <Col xs={3} className="label-right">
                        {resolveLabel(props.labelRight)}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <ProgressBar min={props.min} max={props.max} now={props.now} />
                    </Col>
                </Row>
            </div>
        </Control>
    );
};

export default LabelledProgressBar;
